module.exports = __webpack_public_path__ + "static/media/service-card.db973f76.svg";